import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {repeat} from 'lit/directives/repeat.js';
import {containerStyles, normalizeStyles, typographyStyles} from '@webs/components-library/theming';


@customElement('webs-card-whitepaper')
export class CardWhitepaper extends LitElement {
  static styles = [
    normalizeStyles,
    typographyStyles,
    containerStyles,
    css`
    .bg-grey {
      background-color: var(--color-light-grey);
    }

    .m-card-whitepaper {
      align-items: center;
      border-radius: .6rem;
      display: flex;
      flex-direction: column;
    }


    .m-card-whitepaper__image {
      flex: 0 0 30%;
      max-width: 176px;
      margin: 2.5rem auto 0;
      width: 100%;
    }

    .m-card-whitepaper__title {
      margin-bottom: 0.6rem;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 106%
    }

    li {
      align-items: baseline;
      display: flex;
      margin-bottom: .8rem;
    }

    li:last-child {
      margin-bottom: 0;
    }

    li svg {
      height: 8px;
      margin-right: .7rem;
      width: 12px;
    }

    .reverse {
      flex-direction: column-reverse;
    }

    .reverse .m-card-whitepaper__image {
      margin-top: 0;
      margin-bottom: 2.5rem;
    }

    .variant {
      padding: 2.4rem 2rem 0;
    }

    .variant .m-card-whitepaper__image {
      max-width: 220px;
    }

    @media only screen and (min-width: 768px){
      .m-card-whitepaper {
        align-items: stretch;
        justify-content: center;
      }

      .m-card-whitepaper.variant .m-card-whitepaper__image {
        max-width: 220px;
      }

      .reverse {
        flex-direction: row-reverse;
      }

      .m-card-whitepaper__image {
        flex: 0 0 34%;
        margin: 0;
        max-width: unset;
      }

      .m-card-whitepaper__content {
        padding: 1.2rem 2rem 2rem 0;
      }

      .variant .m-card-whitepaper__image {
        margin: 2rem auto 0;
      }

      .variant .m-card-whitepaper__content {
        padding: 0;
      }

      .reverse .m-card-whitepaper__image {
        margin-bottom: 0;
      }

      .reverse .m-card-whitepaper__content {
        padding: 1.2rem 0 2rem 2rem;
      }
    }

    @media only screen and (min-width: 992px){
      .m-card-whitepaper__content {
        flex: 1;
      }
    }

    @media only screen and (min-width: 1175px){
      .m-card-whitepaper__image {
        margin: 0;
      }

      .reverse .m-card-whitepaper__title {
        text-align: left;
      }

      .reverse .m-card-whitepaper__wrapper {
        align-items: flex-start;
      }
    }
  `
  ];
  @property()
  title: string;

  @property({type: Array})
  items: string[];

  @property({attribute: 'is-grey', type: Boolean})
  isGrey: boolean;

  @property({attribute: 'variant', type: Boolean})
  isVariant: boolean;

  @property({type: Boolean})
  reverse: boolean;

  protected render(): unknown {
    let cardClasses = '';

    if (this.isGrey){
      cardClasses = 'bg-grey';
    }

    if (this.isVariant){
      cardClasses = `${cardClasses} variant`;
    }

    if(this.reverse){
      cardClasses = `${cardClasses} reverse`;
    }

    return html`
      <div class="m-card-whitepaper ${cardClasses}">
        <div class="m-card-whitepaper__content">
          ${this.title ? html`<h5 class="m-card-whitepaper__title">${this.title}</h5>` : ''}
          ${this.items ? html`
              <ul>
                ${repeat(this.items, (item, index) => html`
                  <li class="m-card-whitepaper__item">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 5L5 9L13 1" stroke="#FF8A00" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>

                    <span>${item}</span>
                  </li>
                `)}
              </ul>
            ` : ''}
        </div>

        <div class="m-card-whitepaper__image">
          <slot name="media"></slot>
        </div>
      </div>

    `
  }
}
